exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedor{\r\n  padding-left: 10%;\r\n  padding-right: 10%;\r\n  padding-top: 2%;\r\n  height: 100%;\r\n}\r\n\r\n/* img{\r\n  width: 100px;\r\n} */\r\n\r\ntable{\r\n  text-align: center;\r\n}\r\n\r\ntd{\r\n  vertical-align: middle;\r\n}\r\n\r\n#volver{\r\n  padding-left: 25%;\r\n}\r\n\r\na{\r\n  color: #fa6525;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/mypublications/mypublications.component.css
// module id = ../../../../../src/app/mypublications/mypublications.component.css
// module chunks = main